/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 */

var lastScrollTop = 0;

$(window).scroll(function() {   
	 
    var scroll = $(window).scrollTop();

    if (scroll > lastScrollTop) {
        $("body").addClass("scrolldown");
    } else {
        $("body").removeClass("scrolldown");
    }
	
	lastScrollTop = scroll <= 0 ? 0 : scroll;
	
});

$(document).on('click', 'a[data-action="quick-add-to-cart"]', function () {
   var qty = 1;
   var id = $(this).attr('data-variant-id');

    var params = {
        type: 'POST',
        url: '/cart/add.js',
        data: {
            quantity: qty,
            id: id,
        },
        dataType: 'json',
        success: function(line_item) { 
			if (window.freeGiftHandle) {
	            $.getJSON('/cart.js', function(cart) {
	    			if (cart.total_price > 25000) {
	    				var addFreeGift = true;
				
	    				for (var i = 0; i <= cart.items.length; i++) {
	    	                if (cart.items[i]) {
	    	                    if (cart.items[i].handle == window.freeGiftHandle) {
	    							addFreeGift = false;
	    	                    }
	    	                }
	    	            };
				
	    				if (addFreeGift) {
	    					var qty = 1;
	    				    var id = window.freeGiftId;

	    					var params = {
	    				         type: 'POST',
	    				         url: '/cart/add.js',
	    				         data: {
	    				             quantity: qty,
	    				             id: id
	    				         },
	    				         dataType: 'json',
	    				         success: function(line_item) { 
	    				             document.documentElement.dispatchEvent(new CustomEvent('product:added', {
	    				                 bubbles: true,
	    				                 detail: {
	    				                     quantity: qty
	    				                 }
	    				             }));
	    				         },
	    				         error: function() {
	    				             alert('sold out, sorry!');
	    				         }
	    				      };
	    					  $.ajax(params);
	    				  };
	    			  };
	    		  });
			};
			  
            document.documentElement.dispatchEvent(new CustomEvent('product:added', {
                bubbles: true,
                detail: {
                    quantity: qty
                }
            }));
			if (window.location.href.indexOf("wishlist") > -1) {
				console.log('trigger remove of item from wishlist.');
		    }
        },
        error: function() {
            alert('sold out, sorry!');
        }
     };
     $.ajax(params);
});

// Rewrite /pages/size-guide links to /pages/sizing
document.addEventListener('DOMContentLoaded', function() {
  document.querySelectorAll('a[href*="/pages/size-guide"]').forEach(function(link) {
    link.href = link.href.replace('/pages/size-guide', '/pages/sizing');
  });
});
